module.exports = __webpack_public_path__ + "static/media/timerWithCrown.ac996d65.png";